import { Button, Group, Modal, Space, Text } from '@mantine/core';

import { useProjectsTranslations } from '../hooks';

type Props = {
  opened: boolean;
  isPending: boolean;
  onClose: VoidFunction;
  handleSubmit: VoidFunction;
};

const CreateConfirmationModal = ({ opened, isPending, onClose, handleSubmit }: Props) => {
  const translations = useProjectsTranslations();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={translations.carbonPlanConfirmTitle}
      centered
      size="lg"
    >
      <Text style={{ whiteSpace: 'pre-line' }}>{translations.carbonPlanConfirmBody}</Text>
      <Space h="lg" />
      <Group justify="flex-end">
        <Button variant="outline" onClick={onClose}>
          {translations.cancel}
        </Button>
        <Button type="submit" disabled={isPending} onClick={handleSubmit}>
          {translations.confirm}
        </Button>
      </Group>
    </Modal>
  );
};

export default CreateConfirmationModal;
